
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import './assets/css/global.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import Particles from 'particles.js'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

Vue.use(ElementUI)
Vue.prototype.$particles = Particles

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')